import React,{useState,useEffect,useRef} from "react";
import { Trans, useTranslation} from 'react-i18next'
import AvatarEditor from 'react-avatar-editor'
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import errmsgicon from './../../../../images/errormsgicon.png'
import profilepicempty from './../../../../images/profilepicempty.png'
import Select from 'react-select'
import CrossIcon from './../../../../images/crossicon.png'
import ReactModal from 'react-modal';
import WarningIcon from './../../../../images/warningicon.png'
import Box from '@mui/material/Box';
import minusicon from './../../../../images/minusicon.png'
import plusicon from './../../../../images/plusicon.png'
import Cookies from 'universal-cookie';
import { useNavigate } from "react-router-dom";

function ArtistSettings({toogleOption,toogleTaskbar}){
 const {t, i18n } = useTranslation();
 const [imgsize, setImgSize] =useState(0);
 const [profileImageError,setProfileImageError] = useState(false)
 const [ImageDragActive , setImageDragActive] = useState(false)
 const [profileUrl,setProfileUrl] = useState("")
 const [resizedprofileImg,setResizedProfileImg] = useState("")
 const editor = useRef(null);
 const inputRef = useRef(null)
 const [hoverprofile,setHoverProfile] = useState(false)
 const [artistName,setArtistName] = useState("")
 const [SettingsPopup,setSettingsPopup] = useState()
 const [city,setCity] = useState() 
 const [scale, setScale] = useState(1);
 const [viewSettings,setViewSettings] = useState(false)
 const navigate = useNavigate();
 const [ResizeImgPopup,setResizeImgPopup] = useState(false)
 const [genre,setGenre] = useState()
 const cookies = new Cookies(null ,{ path: '/' });

 useEffect(()=>{
  if(cookies.get("artistname").length!==0){
      setViewSettings(true)
      setArtistName(cookies.get("artistname"))
  }
  toogleOption(1)
},[])
   
 const genreOptions = [{ value: 'Alternative', label: 'Alternative' },
                      { value: 'Audiobooks', label: 'Audiobooks' },
                      { value: 'Blues', label: 'Blues' },
                      { value:'Children’s Music',  label:'Children’s Music'  },
                      { value: 'Classical', label: 'Classical' },
                      { value: 'Comedy', label: 'Comedy' },
                      { value: 'Country', label: 'Country' },
                      { value: 'Dance', label: 'Dance' },
                      { value: 'Electronic', label: 'Electronic' },
                      { value: 'Folk', label: 'Folk' },
                      { value: 'Hip hop/Rap', label: 'Hip hop/Rap' },
                      { value: 'Holiday', label: 'Holiday' },
                      { value: 'Inspirational', label: 'Inspirational' },
                      { value: 'Jazz', label: 'Jazz' },
                      { value: 'Latin', label: 'Latin' },
                      { value: 'New Age', label: 'New Age' },
                      { value: 'Opera', label: 'Opera' },
                      { value: 'Pop', label: 'Pop' },
                      { value: 'R&B/Soul', label: 'R&B/Soul' },
                      { value: 'Reggae', label: 'Reggae' },
                      { value: 'Rock', label: 'Rock' },
                      { value: 'Spoken Word', label: 'Spoken Word' },
                      { value: 'Soundtrack', label: 'Soundtrack' },
                      { value: 'Vocal', label: 'Vocal' },
                      { value: 'World', label: 'World' }]


 const handleImageDrag = (e) =>{
   e.preventDefault();
   e.stopPropagation();

   if (e.type === "dragenter" || e.type === "dragover") {
       setImageDragActive(true);
     } else if (e.type === "dragleave") {
       setImageDragActive(false);
     }
}

const changeGenreHandler = value => {
  setGenre(value)
}

const handleImgResize = (event, newValue) => {
  setImgSize(newValue);
};

const increaseImgScale = () =>{
  if(imgsize<100){
      console.log(imgsize)
      console.log((imgsize-imgsize%10)+10)
      setImgSize((imgsize-imgsize%10)+10)
  }
}



const decreaseImgScale = () =>{
  console.log(imgsize)
  if(imgsize-10>=0){
      setImgSize((imgsize-imgsize%10)-10)
  }
}

useEffect(()=>{
  var newScale= 1+ imgsize/100 
  setScale(newScale)
},[imgsize])

const handleImageDrop = (e) => {
   e.preventDefault();
   e.stopPropagation();
   setImageDragActive(false);
   if (e.dataTransfer.files && e.dataTransfer.files[0]) {
     var filelist=[]

     const img = new Image(); 
     img.src = URL.createObjectURL(e.dataTransfer.files[0])

     img.onload = () => {
       console.log(img.height);
       console.log(img.width);
       if(img.height!==img.width){
         setProfileImageError(true)
       }else if(img.height<3000 || img.height>6000 || img.width<3000 || img.width>6000){
         setProfileImageError(true)
       }else{
         setProfileImageError(false)
         // filelist.push(e.dataTransfer.files[0])
         setProfileUrl([e.dataTransfer.files[0]])
         setResizeImgPopup(true)
       }
     }
   }
}

const handleImageChange = (e) => {
   e.preventDefault();
   console.log("Fired")
   if (e.target.files && e.target.files[0]) {
     const filelist = []
     const img = new Image(); 
     img.src = URL.createObjectURL(e.target.files[0])
     img.onload = () => {
       console.log(img.height);
       console.log(img.width);
       if(img.height!==img.width){
          setProfileImageError(true)
       }else if(img.height<3000 || img.height>6000 || img.width<3000 || img.width>6000){
         setProfileImageError(true)
       }else{
         setProfileImageError(false)
         // filelist.push(e.target.files[0])
         console.log(e.target.files[0])
         setProfileUrl([e.target.files[0]])
         setResizeImgPopup(true)
       }
     }
    
   }
};

const onButtonClick = () => {
   inputRef.current.click();
};

const getImageUrl = async () => {
   const dataUrl = editor.current.getImage().toDataURL()
   const res = await fetch(dataUrl)
   console.log(res)
   const blob = await res.blob()
   console.log(blob)
   console.log(URL.createObjectURL(blob))
   // setProfileUrl([URL.createObjectURL(blob)])
   setResizedProfileImg(window.URL.createObjectURL(blob))
 }


useEffect(()=>{
   console.log(profileUrl)
 },[profileUrl])

const IOSSlider = styled(Slider)(({ theme }) => ({
   color: theme.palette.mode === 'dark' ? '#0a84ff' : '#007bff',
   height: 5,
   padding: '15px 0',
   '& .MuiSlider-thumb': {
     height: 20,
     width: 20,
     backgroundColor: '#fff',
     boxShadow: '0 0 2px 0px rgba(0, 0, 0, 0.1)',
     '&:focus, &:hover, &.Mui-active': {
       boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.1)',
       // Reset on touch devices, it doesn't add specificity
       
     },
     '&:before': {
       boxShadow:
         '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
     },
   },
   '& .MuiSlider-valueLabel': {
     fontSize: 12,
     fontWeight: 'normal',
     top: -6,
     backgroundColor: 'unset',
     color: theme.palette.text.primary,
     '&::before': {
       display: 'none',
     },
     '& *': {
       background: 'transparent',
       color: theme.palette.mode === 'dark' ? '#fff' : '#000',
     },
   },
   '& .MuiSlider-track': {
     border: 'none',
     height: 5,
   },
   '& .MuiSlider-rail': {
     opacity: 0.5,
     boxShadow: 'inset 0px 0px 4px -2px #000',
     backgroundColor: '#d0d0d0',
   },
 }));

const CustomSliderStyles = {
   color:"#dfdfdf",
   '& .MuiSlider-thumb': {
       color: "linear-gradient(97deg, rgba(156,79,255,1) 0%, rgba(130,119,255,1) 100%)",
       height:16,
       width:16,
       backgroundImage:"linear-gradient(97deg, rgba(156,79,255,1) 0%, rgba(130,119,255,1) 100%)"
   },
   '& .MuiSlider-track': {
       color: "transparent",
       height:2
   },
   '& .MuiSlider-rail': {
       color: "#dfdfdf",
       backgroundColor:"#dfdfdf",
       height:2
   },
   '& .MuiSlider-active': {
       color: "none"
   }
};

const colourStyles = {
  control: styles => ({ ...styles,  borderColor: '#636468',
  backgroundColor:'rgba(0,0,0,16%)',
  width: '29.75em',
  height: '3em',
  borderRadius:'8px',
  color:'rgba(255, 255, 255, 1)',
  marginTop:'0.8em'
 }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor:'#18191F' ,
      color:'rgba(255, 255, 255, 1)',
      cursor: isDisabled ? 'not-allowed' : 'default',
      marginTop:'-0.3em',
      marginBottom:'-0.3em'
    };
  },
  input: (styles) => ( {...styles , 
                          FontFamily:'ClashGrotesk-Variable,sans-serif',
                          FontSize:'1rem',
                          FontWeight: 'medium',
                          LineHeight: '150%',
                          LetterSpacing: '0%',
                          color:'rgba(255, 255, 255, 1)'}),
  singleValue : (styles) => ({ ...styles, 
                                  color:'rgba(255, 255, 255, 1)',
                                  FontFamily:'ClashGrotesk-Variable,sans-serif',
                                  FontSize:'1rem',
                                  FontWeight: 'medium',
                                  LineHeight: '150%',
                                  LetterSpacing: '0%'})
};

 return (
     <div style={{display:'flex',flexDirection:'row',position:'relative',paddingBottom:'2.5em',borderRadius:'8px',marginLeft:'2.5em',marginTop:'1.5em',paddingRight:'2em',width:'93.28%',backgroundImage:' linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)'}}> 
                                
                                {
                                profileImageError &&
                                <div style={{display:'flex',flexDirection:'row',position:'absolute',backgroundColor:'#2F0404',paddingTop:'1em',paddingBottom:'1em',top:'1em',borderLeft:'1px solid #FF8686',paddingRight:'2em',left:'5.5em'}}>
                                    <img src={errmsgicon} style={{width:'1.5em',height:'1.5em',marginRight:'1em',marginLeft:'1em'}}/>
                                    <div className="ImageUploadError">
                                    Image must be 3000x3000px - 6000x6000px in size, 72 dpi, 1:1 aspect ratio, in JPEG or PNG format.
                                    </div>
                                </div>
                                }
                                {/* <img src={ArtistProfilePic} alt="Artist Profile Pic" className="ArtistProfilePic"/> */}
                                {/* <div  alt="Profile Pic Empty" className="ArtistProfilePic" style={{backgroundImage:`url(${profilepicempty})`,width:'10.875em',height:'10.875em',marginTop:'5.5em',display:'flex',justifyContent:'center',alignItems:'center',cursor:'pointer'}} onMouseOver={()=>setHoverProfile(true)} onMouseLeave={()=>setHoverProfile(false)}>
                                    {
                                        hoverprofile &&
                                        <div style={{display:'flex',width:'100%',height:'100%',justifyContent:'center',alignItems:'center'}}>
                                             <div style={{width:'98%',height:'98%',backgroundColor:'rgba(0,0,0,50%)',borderRadius:'8px'}}/>
                                            <div className="UploadImageBtn">
                                                Upload <br/> image
                                            </div>
                                        </div>
                                    }
                                   
                                </div> */}
                                {
                                    profileUrl.length===0 &&
                                    <form id="profilepiccontainer" style={{cursor:'pointer',display:'flex',flexDirection:'column',width:'10.875em',height:'10.875em',borderRadius:'8px',marginTop:'5.5em',marginLeft:'5.5em'}} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
                                    <input ref={inputRef} type="file"  id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
                                        <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : "" }>
                                            <div className="CoverPicUpload2" style={{backgroundImage:`url(${profilepicempty})`}} onMouseOver={()=>setHoverProfile(true)} onMouseLeave={()=>setHoverProfile(false)}>
                                            {/* <span className="CoverartText"> 
                                           
                                                <button className="upload-button" onClick={onButtonClick} style={{color:'#C7A5FF',textDecoration:'underline'}}>
                                                {t('Browseyourfiles')} 
                                                        </button> 
                                            </span> */}
                                            {
                                                hoverprofile &&
                                                <div style={{display:'flex',width:'100%',height:'100%',justifyContent:'center',alignItems:'center'}}>
                                                    <div style={{width:'98%',height:'98%',backgroundColor:'rgba(0,0,0,50%)',borderRadius:'8px'}}/>
                                                    {/* <div className="UploadImageBtn" onClick={()=>inputRef.current.click()}>
                                                        Upload <br/> image
                                                    </div> */}
                                                    <button className="upload-button" onClick={onButtonClick} style={{color:'#FFFFFF',textDecoration:'underline',position:'absolute'}}>
                                                    Upload <br/> image
                                                    </button> 
                                                </div>
                                            }
                                            </div>
                                        </label>
                                    
                                    </form>
                                    }
                                

                                {
                                    profileUrl.length!==0 && resizedprofileImg.length ===0 &&
                                    <form id="profilepiccontainer" style={{cursor:'pointer',display:'flex',flexDirection:'column',width:'10.875em',height:'10.875em',borderRadius:'8px',marginTop:'5.5em',marginLeft:'5.5em'}} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
                                    <input ref={inputRef} type="file"  style={{backgroundColor:'pink'}} id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
                                    <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : "" }>
                                        <div onMouseOver={()=>setHoverProfile(true)} onMouseLeave={()=>setHoverProfile(false)} style={{position:'relative'}}>
                                            <img src={URL.createObjectURL(profileUrl[0])} className="CoverPicUpload2"  />
                                            {
                                                hoverprofile &&
                                                <div style={{display:'flex',width:'100%',height:'100%',justifyContent:'center',alignItems:'center',position:'absolute',marginTop:'-10.875em',cursor:'pointer'}}>
                                                    <div style={{width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,50%)',borderRadius:'8px'}}/>
                                                    {/* <div className="UploadImageBtn" onClick={()=>inputRef.current.click()} style={{opacity:'0.5'}}>
                                                       Replace image
                                                    </div> */}
                                                    <button className="upload-button" onClick={onButtonClick} style={{color:'#FFFFFF',textDecoration:'underline',position:'absolute'}}>
                                                    Replace image
                                                    </button> 
                                                </div>
                                            }
                                        </div>
                                    </label>
                                    
                               
                                </form>

                                }

                                {
                                   resizedprofileImg.length!==0 &&
                                    <form id="profilepiccontainer" style={{cursor:'pointer',display:'flex',flexDirection:'column',width:'10.875em',height:'10.875em',borderRadius:'8px',marginTop:'5.5em',marginLeft:'5.5em'}} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
                                    <input ref={inputRef} type="file"  style={{backgroundColor:'pink'}} id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
                                    <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : "" }>
                                        <div onMouseOver={()=>setHoverProfile(true)} onMouseLeave={()=>setHoverProfile(false)} style={{position:'relative'}}>
                                            <img src={resizedprofileImg} className="CoverPicUpload2"  />
                                            {
                                                hoverprofile &&
                                                <div style={{display:'flex',width:'100%',height:'100%',justifyContent:'center',alignItems:'center',position:'absolute',marginTop:'-10.875em',cursor:'pointer'}}>
                                                    <div style={{width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,50%)',borderRadius:'8px'}}/>
                                                    {/* <div className="UploadImageBtn" onClick={()=>inputRef.current.click()} style={{opacity:'0.5'}}>
                                                       Replace image
                                                    </div> */}
                                                     <button className="upload-button" onClick={onButtonClick} style={{color:'#FFFFFF',textDecoration:'underline',position:'absolute'}}>
                                                    Replace image
                                                    </button> 
                                                </div>
                                            }
                                        </div>
                                    </label>
                                    
                                
                                </form>

                                }


                                <div style={{marginTop:'5.2em',marginLeft:'3.125em'}}>
                                    <div className="ProfileSettingHeader">{t('Artistnameheader')}</div>
    
                                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'0.5em',marginBottom:'1.5em'}}> 
                                        <div className="ArtistNameBox">
                                           {artistName}
                                        </div>
    
                                        <div className="ChangeTxt" style={{cursor:'pointer'}} onClick={()=>setSettingsPopup(true)}>
                                        {t('Change')}
                                        </div>
                                    </div>
    
                                    
    
                                    <div className="ProfileSettingHeader">{t('Genre')}</div>
    
                                    <Select options={genreOptions} value={genre} onChange={changeGenreHandler} 
                                        components={{
                                        IndicatorSeparator: () => null
                                        }}
                                        styles={
                                        colourStyles
                                        }
                                        />
    
                                    <div className="ProfileSettingHeader" style={{marginTop:'1.5em'}}>{t('Citybased')}</div>
                                    
                                    {/* <Select options={genreOptions} value={genre} onChange={changeGenreHandler} 
                                        components={{
                                        IndicatorSeparator: () => null
                                        }}
                                        styles={
                                        colourStyles
                                        }
                                        /> */}
    
                                    <input
                                        value={city}
                                        onChange={e => setCity(e.target.value)} 
                                        className='FormInput'
                                        type='text'
                                        // style={{marginLeft:'4.8em'}}
                                        />
                                     <div className="UpdateBtn" style={{marginLeft:'0em',maxWidth:'5.68em'}}>
                                     {t('Save')}
                                     <div className="PostLoginBtnOverlay" style={{left:'0em'}}/>
                                    </div>
                                </div>
               
               <ReactModal
                  isOpen={SettingsPopup}
                  overlayClassName="Overlay"
                  contentLabel="Example Modal"
                  style={{
                     content:{
                     width:'35em',
                     height:'27.18em',
                     margin:'auto',
                     backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                     display:'flex',
                     flexDirection:'column',
                     alignItems:'center',
                     borderRadius:'8px',
                     border:'0.5px solid rgba(255,255,255,25%)'
                     }
                  }}
               >
                  <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setSettingsPopup(false)}/>
                  <img src={WarningIcon} style={{height:'2.62em',width:'2.62em',marginTop:'3em',marginBottom:'1em'}}/>
                  <div className="SettingPopupH1">Important Notice</div>

                  <div className="SettingPopupH2">ANY ADJUSTMENTS MADE IN THIS SECTION WONT'T AUTOMATICALLY AFFECT RELEASES THAT HAVE ALREADY BEEN DISTRIBUTED.</div>

                  <span className="SettingPopupH3">Should you need to reassign previous releases to different artist profiles, please reach out to our <span style={{color:'#E91353'}}>support team</span> for assistance.</span>

                  <div className="IUnderstandBtn" style={{cursor:'pointer'}} onClick={()=>{
                         setSettingsPopup(false);
                         navigate("/Dashboard/settings/artistname")
                        //  navigate("/Dashboard/settings/changeplan");
                      // setViewSettings(false);
                    // setArtistNamePg("artistname")
                    }}>I Understand</div>
               </ReactModal>


               <ReactModal
                    isOpen={ResizeImgPopup}
                    overlayClassName="Overlay"
                    contentLabel="Example Modal"
                    style={{
                        content:{
                        width:'30em',
                        height:'26em',
                        margin:'auto',
                        backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                        display:'flex',
                        flexDirection:'column',
                        alignItems:'center',
                        borderRadius:'8px',
                        border:'0.5px solid rgba(255,255,255,25%)'
                        }
                    }}
                    >
                    <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>{setResizeImgPopup(false);setProfileUrl("")}}/>
                    
                    {/* {
                        profileUrl.length!==0 &&
                        <img src={URL.createObjectURL(profileUrl[0])} style={{borderRadius:'8px',width:'18.58em',height:'18.58em',marginTop:'1em'}}/>
                    } */}

                    {
                        profileUrl.length!==0 &&
                        <AvatarEditor
                        ref={editor}
                        image={URL.createObjectURL(profileUrl[0])}
                        width={250}
                        height={250}
                        border={0}
                        // color={[255, 255, 255, 0.0]} // RGBA
                        scale={scale}
                        rotate={0}
                        borderRadius={16}
                      />
                    }

                    <div style={{display:'flex',flexDirection:'row',marginTop:'2em',marginBottom:'2em',alignItems:'center'}}>
                        <img src={minusicon} className="ImageResizeIcon" style={{width:'1em',height:'1em',padding:'0.5em',marginTop:'-0.2em',cursor:'pointer'}} onClick={()=>decreaseImgScale()}/>
                            <Box sx={{width:250,marginRight:2,marginLeft:2}}>
                            <Slider value={imgsize} onChange={handleImgResize} sx={CustomSliderStyles}/>
                            </Box>
                        <img src={plusicon} className="ImageResizeIcon" style={{width:'1em',height:'1em',padding:'0.5em',marginTop:'-0.2em',cursor:'pointer'}} onClick={()=>increaseImgScale()}/>
                    </div>

                    
                   
                   

                    <div className="IUnderstandBtn" style={{cursor:'pointer',maxWidth:'15em'}} onClick={()=>{getImageUrl();setResizeImgPopup(false);}}>Save image</div>
                </ReactModal>
      </div>
 )
}

export default ArtistSettings;